<template>
  <div v-if="orders.orders !== null && Object.keys(orders.orders).length > 0">


    <section class="c-card--orders__single" v-for="(order, i) in orders.orders" :key="i">
      <cat-order-card v-if="order.source == 'Catalog'" :order="order"></cat-order-card>
      <ro-order-card v-else :order="order"></ro-order-card>
    </section>

    <pagination :pagination="getPagination" :pagingCallback="fetchOrderCallback"></pagination>


  </div>
</template>



<script>
import Paginate from '@/views/components/shared/Paginate'
import CatalogOrderCard from './CatalogOrderCard.vue'
import RewardOpsOrderCard from './RewardOpsOrderCard.vue'
import util from '@/functions'

export default {
  props: [ 'orders', 'fetchOrderCallback' ],
  components: {
    'pagination': Paginate,
    'cat-order-card': CatalogOrderCard,
    'ro-order-card': RewardOpsOrderCard
  },
  computed: {
    getPagination: function () {
      if (this.orders.pagination === null) {
        return this.orders.pagination
      }
      this.orders.pagination.pages = util.getPagination(this.orders.pagination.current, this.orders.pagination.pages)
      return this.orders.pagination
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderList.vue?40a76866